import './Analytic.css';
import { useEffect, useLayoutEffect } from "react";
import { defaultColumnColors } from '../EmissoraColor/EmissoraColor';

export function ReportChartLine({
    customColors,
    audience,
    qtyMinutes,
}) {
    const RootComponent = document.getElementById("root");
    const pUiScreenWidth = parseFloat(RootComponent != undefined ? getComputedStyle(RootComponent).width : '0');
    const pUiScreenHeight = parseFloat(RootComponent != undefined ? getComputedStyle(RootComponent).height : '0');

    const getFillColorAndOpacity = (headers, headerSize) => {
        const type = headers[headerSize] ? headers[headerSize][0] : 0;
        let fillColor;
        if (type === '1') {
          fillColor = '#5A0000';
        } else if (type === '2') {
          fillColor = '#003C5A';
        } else {
          fillColor = '#444444';
        }
        const fillOpacity = 0.4;
        return { fillColor, fillOpacity };
      };

    const chartTopPadding = 30;
    let scaleRating = 5;

    const pRowsHeaders = audience != null && audience.length > 0 ? audience.map(row => row.slice(0, 4)) : [];
    const pRowsColumns = audience != null && audience.length > 0 ? audience[0].slice(4).map((_, i) => audience.map(row => row[i + 4] === '0' ? '-' : row[i + 4])) : [];
    const pChartHeight = (pUiScreenHeight - chartTopPadding - 140) / 2

    function enableTooltip(visibilityStatus, valueFromChart) {
        const divTooltip = document.getElementById("tooltip-line")!;
        window.addEventListener('mousemove', function (event) {
            const x = event.clientX - 10;
            const y = event.clientY - 15;
            divTooltip.style.visibility = visibilityStatus;
            divTooltip.style.left = x + "px";
            divTooltip.style.top = y + "px";
            divTooltip.style.zIndex = "1";
            divTooltip.style.fontWeight = 'bold';
            divTooltip.style.fontSize = "10px";
            divTooltip.style.backgroundColor = '#f2f5f9';
            const chartValue = divTooltip.querySelectorAll("text")
            chartValue[0].innerHTML = (valueFromChart);
        }, false);
    }

    function parseData(valueString) {
        if (valueString === undefined) {
            return [0, 0];
        }
        valueString = valueString.indexOf('|') !== -1 ? valueString : valueString + '|0';
        const values = valueString.split('|');
        const parsedValues = values.map(value => parseFloat(values[0]));

        return [
            isNaN(parsedValues[0]) ? 0 : parsedValues[0],
            isNaN(parsedValues[1]) ? 0 : parsedValues[1]
        ];
    }

    function arrScaleY(columns: string[][]): number[] {
        let arrScaleY: number[] = [];
        let maxValue: number = 0;
        columns.forEach((c, index) => {
            c.forEach((cell, cellIndex) => {
                if (cellIndex < qtyMinutes - 1) {
                    const value = parseData(cell)[0];
                    maxValue = Math.max(maxValue, value);
                    scaleRating = maxValue > 1000 ? 500000 : 5;
                }
            });
        });

        const restOfDivision = maxValue % scaleRating;
        if (restOfDivision > 0) {
            maxValue = maxValue + (scaleRating - restOfDivision);
        }

        while (maxValue >= 0) {
            arrScaleY.push(maxValue);
            maxValue = maxValue - scaleRating;
        }
        return arrScaleY;
    }

    function renderCircleElements(circleElementsParams) {
       
        let { c, nLinhas, xLabelsSpace, xValue, index, headers, headerSize, backgroundColor, pChartHeight, yLabelsSpace, scaleRating, enableTooltip, pathLine } = circleElementsParams;

       
       
       
       
        return c.map((cell, cellIndex) => {
            headerSize -= 1;
            if (cellIndex < nLinhas) {
                if (cellIndex > 0) {
                    xValue = xValue + xLabelsSpace;
                }

                const textElement = renderTextElement(index, cellIndex, xValue, xElementsYValue, headers, headerSize);
                if (textElement) {
                    xElements.push(textElement);
                }

                const value = parseData(cell)[0];
                const cy = pChartHeight - value * (yLabelsSpace / scaleRating);
                const txtLine = cellIndex === 0 ? 'M' : 'L';
                pathLine.push(`${txtLine} ${xValue} ${cy}`); 

                if (index === 0) {
                    const { fillColor, fillOpacity } = getFillColorAndOpacity(headers, headerSize);

                    rectElements.push(
                        <rect
                            key={cellIndex}
                            x={xValue}
                            y={10}
                            width={xLabelsSpace - 0.5}
                            height={pChartHeight - 10}
                            fill={fillColor}
                            fillOpacity={fillOpacity}
                        />
                    );
                }
                return (
                    <circle
                        key={cellIndex}
                        cx={xValue}
                        cy={cy}
                        fill={backgroundColor}
                        r="3"
                        onMouseEnter={() => enableTooltip('visible', value)}
                        onMouseLeave={() => enableTooltip('hidden', value)}></circle>
                );
            }
        });
    }

    useLayoutEffect(() => { }, []);
    useEffect(() => { }, []);

    const chartWidth = pUiScreenWidth - 30;
    const space = 20;
    const areaWidth = chartWidth + space;
    const areaHeight = pChartHeight + space - 60;

    let yElements: any[] = [];
    let dataElements = null;
    let xElements: any[] = [];
    let rectElements: any[] = [];
    let xElementsYValue = areaHeight - 4;

    let nLinhas;
    if (pRowsHeaders.length > qtyMinutes) {
        nLinhas = qtyMinutes;
    } else if (pRowsHeaders.length <= qtyMinutes) {
        nLinhas = pRowsHeaders.length;
    } else {
        nLinhas = 0;
    }
        const renderTextElement = (index, cellIndex, xValue, xElementsYValue, headers, headerSize) => {
        if (index === 0 && (cellIndex === 0 || cellIndex % 5 === 0)) {
          return (
            <text
              key={cellIndex}
              x={xValue - 10}
              y={xElementsYValue}
              fill="#000"
              style={{ fontSize: 9 }}
            >
              {headers[headerSize][1]}
            </text>
          );
        }
        return null;
      };


    if (nLinhas > 0) {
        const yLabels = arrScaleY(pRowsColumns);
        const yLabelsSpace = pChartHeight / yLabels.length;
        let yValue = yLabelsSpace;
        yElements = yLabels.map((y, li) => {
            if (li > 0)
                yValue += yLabelsSpace;
            return (
                <text
                    key={li}
                    x="4"
                    y={yValue + 4}
                    fill="#000"
                    style={{ fontSize: 9 }}>{y}</text>
            );
        });

        const xLabelsSpace = (chartWidth - space) / nLinhas;
        const columnColors = customColors ?? defaultColumnColors;
        const headers = pRowsHeaders.length >= qtyMinutes ? pRowsHeaders.slice(0, qtyMinutes) : pRowsHeaders;

        let headerSize = headers.length;

        dataElements = pRowsColumns.map((c, index) => {
            const backgroundColor = columnColors[index % columnColors.length];
            let xValue = space;
            const pathLine: string[] = [];
            c.reverse();
            if (c.length > qtyMinutes) {
                c = c.slice(Math.max(c.length - qtyMinutes));
            }
            let renderCircleElementsParams = { c, nLinhas, xLabelsSpace, xValue, index, headers, headerSize, backgroundColor, pChartHeight, yLabelsSpace, scaleRating, enableTooltip, pathLine };

            const circleElements = renderCircleElements(renderCircleElementsParams);
            
            return (
                <g key={index}>
                    <g>
                        <path d={pathLine.join('  ')} fill="none" stroke={backgroundColor} strokeWidth="1px" />
                    </g>
                    <g>
                        {circleElements}
                    </g>
                </g>
            );
        });

    }


    return (
        <div className='DivDado' style={{ textAlign: 'center' }}>
            <div
                id="tooltip-line"
                data-testid="tooltip-line"
                style={{
                    position: 'fixed',
                    height: '40px',
                    width: '35px',
                    visibility: 'hidden',
                    top: '1',
                    left: '1',
                    marginBottom: '50px',
                    color: '#000000',
                    textAlign: "center",
                    borderRadius: '3px',
                }}
            >
                <text></text>
            </div>

            <svg
                width={areaWidth - 10}
                height={areaHeight}
                style={{
                    bottom: 0,
                    backgroundColor: '#fff',
                    overflow: 'hidden',
                }}
            >
                <g id="xGrid">
                    <line x1={space} x2={space} y1="10" y2={pChartHeight} stroke="#000" strokeWidth="1px"></line>
                </g>
                <g id="yGrid">
                    <line x1={space} x2={chartWidth} y1={pChartHeight} y2={pChartHeight} stroke="#000" strokeWidth="1px"></line>
                </g>
                <g id="xLabels">
                    {xElements}
                </g>
                <g id="yLabels">
                    {yElements}
                </g>
                <g id="rectElements">
                    {rectElements}
                </g>
                {dataElements}
            </svg>
        </div>
    );
}